export function dateMask(value) {
  if (!value) return ''
  value = value.replace(/\D/g, '')
  if (value.length > 2) {
    value = value.slice(0, 2) + '/' + value.slice(2)
  }
  if (value.length > 5) {
    value = value.slice(0, 5) + '/' + value.slice(5)
  }
  return value
}

export function formatarDataHoraParaBrasileiro(dataHora) {
  // Separar a data e a hora
  let partes = dataHora.split(' ')
  let data = partes[0]
  let hora = partes[1]

  // Separar os componentes da data
  let dataComponentes = data.split('-')
  let ano = dataComponentes[0]
  let mes = dataComponentes[1]
  let dia = dataComponentes[2]

  // Separar os componentes da hora
  let horaComponentes = hora.split(':')
  let horas = horaComponentes[0]
  let minutos = horaComponentes[1]
  let segundos = horaComponentes[2]

  // Construir a string formatada
  let dataHoraFormatada = dia + '/' + mes + '/' + ano + ' ' + horas + ':' + minutos + ':' + segundos

  return dataHoraFormatada
}

export function formatarDataPtBr(data?: string | null): string {
  if (!data) return '' // ou '—' se quiser um placeholder

  const partes = data.split('-')

  // valida formato básico YYYY-MM-DD
  if (partes.length !== 3) return ''

  const [ano, mes, dia] = partes.map(Number)

  // valida números
  if (!ano || !mes || !dia) return ''

  const date = new Date(ano, mes - 1, dia)

  const formatada = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(date)

  return formatada.charAt(0).toUpperCase() + formatada.slice(1)
}

export function getMesNome(data?: string | null): string {
  if (!data) return ''

  const [ano, mes, dia] = data.split('-').map(Number)
  if (!ano || !mes || !dia) return ''

  const date = new Date(ano, mes - 1, dia)

  const nomeMes = new Intl.DateTimeFormat('pt-BR', {
    month: 'long',
  }).format(date)

  return nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1)
}
